import React, { Component, Fragment, createElement } from "react";
import Loading from "../../../shared/Loading/Loading";
import Card from "../../../shared/Card/Card";
import { formatCurrency } from "../../../../js/shared/utils";
import {
	formatDateToPortugueseFormatReducedYear,
	decDaysToDate,
	formatDateToComputerDate
} from "../../shared/utils";
import Button from "../../../shared/button/button";
import { withGetScreen } from "react-getscreen";

class RankingAnalyze extends Component {
	constructor(props) {
		super(props);

		this.state = {
			handleMessage: false
		};
	}

	render() {
		const { loading, analyze, ...props } = this.props;

		const handleMessageFn = e => {
			this.setState({
				handleMessage: !this.state.handleMessage
			});
		};

		const buttonArrowMessage = createElement(
			Button,
			{
				className: "btn-secondary-md-label offers-ranking-page--message-button",
				onClick: handleMessageFn
			},
			this.state.handleMessage ? <i className="icon-arrow-up" /> : <i className="icon-arrow-down" />
		);

		if (analyze === undefined || !analyze.hasOwnProperty("price24HoursAgo")) {
			return null;
		}

		return (
			<Fragment>
				<h1 className={`offers-ranking-page__title text-center ${props.isMobile() ? "" : "pt-32"}`}>
					COTAÇÃO DE MILHAS
				</h1>
				<p
					className="offers-ranking-page--p text-center font-size-small plr-16"
					style={{ maxHeight: this.state.handleMessage ? "100px" : "0px" }}
				>
					Aqui, você confere a <strong>média</strong> de preço de cada 1.000 milhas vendidas na
					MaxMilhas, calculada
					<br />
					entre 0h e 23h59 de cada período. A <strong>variação</strong> compara o valor médio das
					últimas 24 horas com as diferentes datas.
				</p>
				{buttonArrowMessage}

				<Fragment>
					<div className="offers-ranking-page__cards">
						<Card className="offers-ranking-page__cards--card offers-ranking-page__cards--green-card">
							<h3 className="offers-ranking-page__cards--title">Últimas 24h</h3>
							{loading ? (
								<Loading />
							) : (
								<p>
									Média:{" "}
									<strong>
										{formatCurrency(
											analyze && analyze.price24HoursAgo ? analyze.price24HoursAgo : 0
										)}
									</strong>
								</p>
							)}
						</Card>
						<Card className="offers-ranking-page__cards--card">
							<h3 className="offers-ranking-page__cards--title">
								{formatDateToPortugueseFormatReducedYear(
									decDaysToDate(formatDateToComputerDate(new Date()), 3)
								)}
								<small className="font-size-small">-3 dias</small>
							</h3>
							{loading ? (
								<Loading />
							) : (
								<Fragment>
									<p>
										Média:{" "}
										<strong>
											{formatCurrency(analyze && analyze.price3DaysAgo ? analyze.price3DaysAgo : 0)}
										</strong>
									</p>
									<p>
										Variação:
										<span>
											{analyze.percent3DaysAgo >= 0
												? `+${analyze.percent3DaysAgo}%`
												: `${analyze.percent3DaysAgo}%`}
										</span>
									</p>
								</Fragment>
							)}
						</Card>
						<Card className="offers-ranking-page__cards--card">
							<h3 className="offers-ranking-page__cards--title">
								{formatDateToPortugueseFormatReducedYear(
									decDaysToDate(formatDateToComputerDate(new Date()), 7)
								)}
								<small className="font-size-small">-7 dias</small>
							</h3>
							{loading ? (
								<Loading />
							) : (
								<Fragment>
									<p>
										Média:{" "}
										<strong>
											{formatCurrency(analyze && analyze.price7DaysAgo ? analyze.price7DaysAgo : 0)}
										</strong>
									</p>
									<p>
										Variação:
										<span>
											{analyze.percent7DaysAgo >= 0
												? `+${analyze.percent7DaysAgo}%`
												: `${analyze.percent7DaysAgo}%`}
										</span>
									</p>
								</Fragment>
							)}
						</Card>
						<Card className="offers-ranking-page__cards--card">
							<h3 className="offers-ranking-page__cards--title">
								{formatDateToPortugueseFormatReducedYear(
									decDaysToDate(formatDateToComputerDate(new Date()), 30)
								)}
								<small className="font-size-small">-30 dias</small>
							</h3>
							{loading ? (
								<Loading />
							) : (
								<Fragment>
									<p>
										Média:{" "}
										<strong>
											{formatCurrency(
												analyze && analyze.price30DaysAgo ? analyze.price30DaysAgo : 0
											)}
										</strong>
									</p>
									<p>
										Variação:
										<span>
											{analyze.percent30DaysAgo >= 0
												? `+${analyze.percent30DaysAgo}%`
												: `${analyze.percent30DaysAgo}%`}
										</span>
									</p>
								</Fragment>
							)}
						</Card>
					</div>
					<div className="offers-ranking-page__cards-footer">
						<small className="font-weight-bold">Última atualização: {analyze.lastUpdate}</small>
						<small className="font-weight-bold">Próxima atualização: {analyze.nextUpdate}</small>
					</div>
				</Fragment>
			</Fragment>
		);
	}
}

export default withGetScreen(RankingAnalyze);
